<advanced-filter (onSubmit)="applyFilter()" *ngIf="isCoLogin()"></advanced-filter>
<app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>
<wl-card heading="ETB ({{totalCount}})" subheading1="{{subheading1}}" subheading2="{{subheading2}}"
  *ngIf="showEtbDataTable">
  <!-- <input class="date" type="month" id="start" name="start" min="2022-01" [max]="maxDate" [(ngModel)]="formatFilterTableDate"    #date1
  >

  <button class="ml-10px mybutton bb" (click)="submitDates()">Submit</button> -->

  <wl-date-input (dateRangeSelected)="onDateRangeSelected($event)" *ngIf="!isCoLogin()"></wl-date-input>

  <span *ngIf="showSelectedDate  && !isCoLogin()" class="datetext">&nbsp;&nbsp;{{selectedDate}}&nbsp;&nbsp;<img
      src="../../../assets/fontawesome-web/svgs/regular/rectangle-xmark.svg" class="h-15px"
      (click)="closeButtonClick()">
  </span>
  <!-- <div>
    <mat-form-field class="w-full">
      <input type="text" matInput placeholder="{{searchHolder}}" (input)="onSearchClick($event)" [formControl]="search"><img
        class="ml-neg30px-important" src="../../../assets/svg/search.svg">
    </mat-form-field>
  </div> -->
  <wl-search-input (searchValueChanged)="onSearch($event)" [ngClass]="{'search': isCoLogin()}"></wl-search-input>
  <br>
  <p *ngIf="noUserFound" class="m-100px text-center font-size-15em">{{noUserFound}}</p>

  <div class="font-size-12px table-responsive" *ngIf="!noUserFound" child-container>
    <table class="table table-hover table-scrollable">
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th>Loan Reference No.<br>
          <th>Customer ID<br>
          <th>Customer Name<br>
          <th>Sanctioned Amount<br>
          <th>Sanction Date<br>
            <!-- <th>Branch</th> -->
          <th *ngIf="showChecksColumn">Checks</th>
          <th>Application Status<br></th>
          <th *ngIf="showSanctionedDocuments">Download <br> Sanctioned <br> Documents</th>
          <th *ngIf="showDownloadUploadColumn">Upload/ <br> Download <br> Documents</th>
          <!-- <th>Download documents<br> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of allUsersNew;let i = index;">
          <td class="vertical-align-middle">
            <p>{{10 *(pageId-1)+i+1}}</p>
          </td>
          <td class="vertical-align-middle">
            <p>{{(user?.ubi_reference_no) ? user.ubi_reference_no : '' }}</p>
          </td>
          <td class="vertical-align-middle">
            <p>{{(user?.custId) ? user.custId : '' }}</p>
          </td>
          <td class="vertical-align-middle">
            <p>{{
              (user?.profile?.first_name) ? user.profile.first_name : ""
              }}</p>
          </td>
          <td class="vertical-align-middle">
            <p>{{(user?.croppingPatternProposed?.colU) ? user.croppingPatternProposed?.colU : '' }}</p>
          </td>
          <td class="vertical-align-middle">
            <p>{{user?.loanApplicationDate | date:'d/M/yy'}}</p>
          </td>
          <!-- <td class="vertical-align-middle">
              <p>{{user?.branch}}</p>
            </td> -->
          <td class="vertical-align-middle" *ngIf="showChecksColumn">
            <div *ngFor="let item of user.checkBoxesList; let j = index"
              [ngStyle]="{'opacity': user.isCheckBoxesSubmitted ? '0.5' : '1'}">
              <input type="checkbox" [id]="item.code" [value]="item.code"
                class="pb-1rem h-125rem w-125rem" (change)="toggleCheckbox(i, j)"
                [checked]="item.checked" [ngStyle]="{'pointer-events': user.isCheckBoxesSubmitted ? 'none' : 'auto'}">
              <label [for]="item.code" [ngStyle]="{'pointer-events': user.isCheckBoxesSubmitted ? 'none' : 'auto'}">{{
                item.desc }}</label>
              <span class="info-tooltip" *ngIf="item.code === lienCheckBoxCode">
                <span class="info-icon">i</span>
                <span class="info-tooltip-text">{{ lienCheckBoxInfo }}</span>
              </span>
            </div>
            <br>
            <button *ngIf="!user.isCheckBoxesSubmitted" class="mybutton"
              [disabled]="!user.isAllChecked || user.isCheckBoxesSubmitted"
              (click)="submitCheckBoxes(user, i)">Submit</button>

            <button *ngIf="user.isCheckBoxesSubmitted" class="mybutton"
              [disabled]="!user.isAllChecked || !user.isCheckBoxesSubmitted || user?.loanAccountCreated"
              (click)="createLoanAccount(user, i)">Create Loan Account</button>
            <br>
          </td>
          <td class="vertical-align-middle">
            <p>{{getAppStatusMessage(user?.appStatus)}}</p>
          </td>
          <td (click)="getDocs(user);" class="download-docs vertical-align-middle"
            *ngIf="showSanctionedDocuments">
            <P>Download</P>
          </td>
          <td class="vertical-align-middle cursor-pointer" *ngIf="showDownloadUploadColumn">
            <p class="text-underline" (click)="uploadPopup(user)">Upload</p>

            <p class="text-underline" (click)="downloadPopup(user)">Download</p>

          </td>
        </tr>
      </tbody>
    </table>
  </div>

</wl-card>

<div class="modal-background" *ngIf="showModal">
  <div class="modal-content">
    <wl-file-drag-upload (filesUploaded)="handleFilesUploaded($event)" (close)="handleClose()"
      [applicantId]="currentUser.id">Upload</wl-file-drag-upload>
  </div>
</div>

<div class="modal-background" *ngIf="showDownloadModal">
  <div class="modal-content">
    <wl-file-download-modal [applicantId]="currentUser.id"
      (close)="handleCloseDownload()">Download</wl-file-download-modal>
  </div>
</div>

<!--Moadal for Download Doc-->
<div class="modal-background" *ngIf="showDownloadDocsModal">
  <!-- <ng-template #downloadModal let-modal> -->
  <div class="modal-content p-0">
    <div class="modal-header1">

      <h4 class="modal-title" id="modal-basic-title">Download Documents</h4>
      <button type="button" class="close_icon" (click)="closeDownloadDocModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body-confirm text-left">
      <h4>Please select the documents to be downloaded:</h4>
      <ng-container *ngFor="let form of downloadForms; let idx = index;">
        <input type="checkbox" [id]="'myCheck1'+idx" [(ngModel)]="form.isChecked" />
        <label>{{form.label | titlecase}}</label> <br>
      </ng-container>
      <input type="checkbox" id="uniqueCheckboxDisbursed" (change)="changeAccWiseBre($event)" #checkRef
        *ngIf="showAccwiseBreCheckBox" /> <label *ngIf="showAccwiseBreCheckBox">Account
        wise BRE check</label><br>
      <input type="checkbox" [id]="'myCheck2'+idx" (change)="selectAllDownloadForms($event)" />
      <label>All</label> <br>
    </div>

    <div class="modal-footer">
      <div class="w3-show-inline-block text-center">
        <div class="w3-bar">
          <button class="mybutton" (click)="downloadMyForms()">Download</button>
        </div>
      </div>
    </div>
  </div>
  <!-- </ng-template> -->

</div>

<!--Moadal for Download Doc-->

<nav class="flex-center" *ngIf="totalPage>1" aria-label="Page navigation example">
  <ul class="pagination">
    <!-- limit - 10 -->
    <li *ngIf="page>3"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">Previous</a></li>
    <li *ngIf="page>2"><a (click)="getAllUsersPage(filter,roleId,offset - 20,10,page - 2)">{{page - 2}}</a></li>
    <li *ngIf="page>1"><a (click)="getAllUsersPage(filter,roleId,offset - 10,10,page - 1)">{{page - 1}}</a></li>
    <li class="page-item active"><a (click)="getAllUsersPage(filter,roleId,offset,10,page)">{{page}}</a></li>
    <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">{{page + 1}}</a></li>
    <li *ngIf="page+1<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 20,10,page + 2)">{{page + 2}}</a>
    </li>
    <li *ngIf="page<totalPage"><a (click)="getAllUsersPage(filter,roleId,offset + 10,10,page + 1)">Next</a></li>
  </ul>
</nav>